import { Component, HostListener } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'lemsar-front-page',
    templateUrl: './front.page.html',
    styleUrls: ['./front.page.scss'],
})
export class FrontPage {
    public shortHeader: boolean = false;

    public constructor(public router: Router, public route: ActivatedRoute) {}

    @HostListener('window:scroll', ['$event'])
    public checkScroll(): void {
        if (window.pageYOffset < 150) {
            this.shortHeader = false;
        } else {
            this.shortHeader = true;
        }
    }
}



// WEBPACK FOOTER //
// ./apps/frontend/src/template/default/pages/front.page.ts